import styled from "@emotion/styled";
import { Button } from "react-aria-components";

export const PopupDialogTriggerButton = styled(Button)`
  display: flex;
  height: 44px;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
`;
